import { useEffect } from "react";
import { API } from "@/lib/apiClient";

const SITE_NAME = "National Public Service Trust";

function setMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!content) return;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export default function SEO({ route, title, description, canonical, image, jsonLd, noindex }) {
  useEffect(() => {
    const path = route || window.location.pathname;
    let cancelled = false;
    let ldEl = null;

    const apply = (seo) => {
      seo = seo || {};
      const finalTitle = seo.title || title || seo.site_default_title || SITE_NAME;
      const finalDesc = seo.description || description || seo.site_default_description || "";
      const finalCanonical = seo.canonical || canonical || window.location.href;
      const finalImage = image || seo.og_image || `${window.location.origin}/npst-logo.webp`;
      const ogTitle = seo.og_title || finalTitle;
      const ogDesc = seo.og_description || finalDesc;
      const noIdx = noindex !== undefined ? noindex : seo.noindex;

      document.title = finalTitle;
      setMeta("description", finalDesc);
      setMeta("robots", noIdx ? "noindex, nofollow" : "index, follow");
      setMeta("og:title", ogTitle, "property");
      setMeta("og:description", ogDesc, "property");
      setMeta("og:type", "website", "property");
      setMeta("og:site_name", SITE_NAME, "property");
      setMeta("og:image", finalImage, "property");
      setMeta("og:url", finalCanonical, "property");
      setMeta("og:locale", "en_IN", "property");
      setMeta("twitter:card", "summary_large_image");
      setMeta("twitter:title", ogTitle);
      setMeta("twitter:description", ogDesc);
      setMeta("twitter:image", finalImage);
      setLink("canonical", finalCanonical);

      if (ldEl) { document.head.removeChild(ldEl); ldEl = null; }
      if (jsonLd) {
        ldEl = document.createElement("script");
        ldEl.type = "application/ld+json";
        ldEl.text = JSON.stringify(jsonLd);
        document.head.appendChild(ldEl);
      }
    };

    apply({});
    fetch(`${API}/seo?route=${encodeURIComponent(path)}`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((seo) => { if (!cancelled && seo) apply(seo); })
      .catch(() => {});

    return () => { cancelled = true; if (ldEl && ldEl.parentNode) document.head.removeChild(ldEl); };
  }, [route, title, description, canonical, image, jsonLd, noindex]);

  return null;
}
